<template>
	<custom-popover class="template-stats-popover" :backdrop="true"  @close="$emit('close')">
        <!-- <img @click.stop.prevent="onClose()" class="close-popover" src="@/assets/svg/close.svg"> -->
        <div class="popover-header">
            <div class="left-side-header">
                <h2>{{$t('stats-popover.title')}}</h2>
                <span>- {{selectedDataset? selectedDataset.referenceName: $t('variables.example') }}</span>
            </div>
            
            <div class="close-popover" @click.stop.prevent="onClose()">
                <i class="fa-light fa-times"></i>
            </div>
            
        </div>
        <div class="stat-wrapper">
            <div class="var-progress stat">
                <h3>{{$t('progress-bar.title-in-use')}}</h3>
                <progress-circle 
                    :maxAmount="variables.length" 
                    :activeAmount="usedVars"
                    :circleSize="170"
                    :strokeWidth="10"
                    :textSize="45"
                />
                <usage-counter
                    class="usage-count"
                    :usageAmount="usedVars"
                    :maxAmount="variables.length"
                    :dangerZone="100" 
                />
                <div>
                    <h3> {{$t('progress-bar.title-total')}}</h3>
                    <p><animate-text :number="totalAmount" :animateTime="10"/></p> 
                </div>
            </div>

            <TemplateStatsCalculator class="text-stats stat" :allText="allText" />
        </div>
	</custom-popover>
</template>
<script>
import CustomPopover from '@/components/CustomPopover'
import VariableHelpers from '@/assets/js/variableHelpers'
// import ProgressBar from '@/components/ProgressBar'
import ProgressCircle from '@/components/ProgressCircle'
import UsageCounter from '@/components/UsageCounter'
import TemplateStatsCalculator from '@/components/TemplateStatsCalculator'
import AnimateText from '@/components/AnimateText.vue'
export default {
  name: "templateStatsPopover",
  data() {
    return {
        totalVars: Object.values(VariableHelpers.countVariablesInTemplate(this.$store.state.template)),
        usedVars: Object.keys(VariableHelpers.countVariablesInTemplate(this.$store.state.template)).length,
        variables: this.$store.state.templateVariables,
        template: this.$store.state.template,
        loading: false,
		}
    },
    props:{
        allText: Array,
        selectedDataset: Object
    },
 methods:{
     onClose () {
		this.$emit('close')
    },
 },
computed:{
     totalAmount: function () {
        let sum = 0;
        this.totalVars.forEach(e => {
            sum += e;
        });
        return sum
    },
},
  components:{
      CustomPopover,
      TemplateStatsCalculator,
      ProgressCircle,
      UsageCounter,
      AnimateText
    
  }
}
</script>
<style lang="less">
    .template-stats-popover {
        width: 740px;
        height: 500px;
		line-height: 1.5;
		background-color: #fff;
		position: absolute;
        color: #3d464a;
		&.custom-popover {
			background-color: #fff;
			right: calc(50% - (740px / 2));
			left: unset;
			top: calc(50% - (500px / 2));
			&::before {
				// content: url(*/svg/close.svg);
				display: none;
			}

			.close-button {
				display: none;
            } 
        }
    img.close-popover{
	position: absolute;
    top: -9px;
    right: -8px;
	z-index: 101;
	cursor: pointer;
		} 
        .stat-wrapper{  
            padding: 40px;
            height: 449px;
            background-color: #fff;  
            display: grid;
            // display: flex;
            // justify-content: center;
            grid-gap: 40px;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: 1fr 1fr;
            border-radius: 0 0 10px 10px;
            .stat{
                border-radius: var(--standard-border-radius);
                padding: 20px;
                background-color: #fff;
                box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.25);
                grid-row-start: 1;
                grid-row-end: 3;
                p{
                    margin-bottom: 0;
                    font-size: 14pt;
                    cursor: default;
                }
                h3{
                    font-size: 16px;
                    margin-bottom: 0;
                }
                .lighter{
                    font-size: 10pt;
                }

                .underline{
                    text-decoration: underline var(--flame);
                }
            }   
        }
        .var-progress{
            border-radius: var(--standard-border-radius);
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: center;
            .usage-count{
                position: absolute;
                top: 55%;
                .counter{
                    font-size: 16px;
                }
            }
            div{
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }

        .popover-header{
            color: var(--charcoal);

            .left-side-header{
                display: flex;
                gap: 8px;
            }
        }
	}

</style>


